// The full-screen call grows out of the coach face it was opened from (the bottom
// nav avatar). Starting a call can wait on the mic prompt, so the origin is kept a
// few seconds and used once.
const KEEP_MS = 8000
let origin: { x: number; y: number; r: number; at: number } | null = null

export function markCallOrigin(el: Element | null) {
  if (!el) return
  const b = el.getBoundingClientRect()
  origin = { x: b.left + b.width / 2, y: b.top + b.height / 2, r: b.width / 2, at: Date.now() }
}

export function revealCallFrom(el: HTMLElement | null) {
  const o = origin
  if (!el || !o) return
  origin = null
  if (Date.now() - o.at > KEEP_MS) return
  if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) return
  el.animate(
    [
      { clipPath: `circle(${o.r}px at ${o.x}px ${o.y}px)` },
      { clipPath: `circle(150vmax at ${o.x}px ${o.y}px)` },
    ],
    { duration: 480, easing: 'cubic-bezier(0.2, 0.8, 0.2, 1)' },
  )
}
